import React, { Component } from 'react';
import axios from '../../utils/request';
import { Spinner } from 'reactstrap';
import { Result } from 'antd';

export class SanQiHuYuSendSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            isReady: false,
            sendStatus: false,
        };
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const templateCode = urlParams.get("templateCode");
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        const params = {
            templateCode,
            tenantId,
            commonParamater
        }
        axios.get("/api/SanQiHuYu/SendWrittenPaper", { params: params })
            .then(res => {
                const data = res.data.data;
                if (data === "") {
                    this.setState({ sendStatus: true, isReady: true, message: "笔试发送成功，点击右上角关闭" });
                } else {
                    this.setState({ sendStatus: false, isReady: true, message: data });
                }
            })
    };

    render() {
        if (this.state.isReady) {
            if (this.state.sendStatus) {
                return (
                    <Result
                        status="success"
                        title="笔试发送成功"
                        subTitle="应聘者的笔试已发送完成，点击右上角关闭此页面."
                    />
                )
            } else {
                return (
                    <Result
                        status="warning"
                        title="笔试发送失败."
                        subTitle={this.state.message}
                    />)
            }
        } else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}
